import api from "./api";

const DashboardService = {

    getDashboardSummary(payload) {
        return api.post(`hse/get_hse_summary`,payload)
    },
    getLineChartData(payload) {
        return api.post(`hse/get_ai_model_performance_trend`,payload)
    },
    getRecentAlerts(payload) {
        return api.post(`hse/get_live_alerts`,payload)
    },
    getAlertsDistribution(payload) {
        return api.post(`hse/get_hse_alerts_module_wise`,payload)
    },
    getAlertZoneWise(payload) {
        return api.post(`hse/get_hse_alerts_by_zone`,payload)
    }

}


export default DashboardService;